import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import { usefulLinksReducer, initialState, IUsefulLinksState, IUsefulLinksAction } from './useful-links-reducer';

const UsefulLinksStateContext = createContext<IUsefulLinksState | undefined>(undefined);
const UsefulLinksDispatchContext = createContext<React.Dispatch<IUsefulLinksAction> | undefined>(undefined);

interface UsefulLinksProviderProps {
    children: ReactNode;
}

export const UsefulLinksProvider: React.FC<UsefulLinksProviderProps> = ({ children }) => {
    const [state, dispatch] = useReducer(usefulLinksReducer, initialState);

    return (
        <UsefulLinksStateContext.Provider value={state}>
            <UsefulLinksDispatchContext.Provider value={dispatch}>
                {children}
            </UsefulLinksDispatchContext.Provider>
        </UsefulLinksStateContext.Provider>
    );
};

export const useUsefulLinksState = (): IUsefulLinksState => {
    const context = useContext(UsefulLinksStateContext);
    if (context === undefined) {
        throw new Error('useUsefulLinksState must be used within a UsefulLinksProvider');
    }
    return context;
};

export const useUsefulLinksDispatch = (): React.Dispatch<IUsefulLinksAction> => {
    const context = useContext(UsefulLinksDispatchContext);
    if (context === undefined) {
        throw new Error('useUsefulLinksDispatch must be used within a UsefulLinksProvider');
    }
    return context;
};
